import 'Plugins/responsiveHelper';
import 'Plugins/tabsPlugin';

// content tabs init
export default function initTabs() {
	ResponsiveHelper.addRange({
		'1024..': {
			on: function() {
				jQuery('.bucket-features .tabset').tabset({
					tabLinks: 'a',
					defaultTab: true
				});
			},
			off: function() {
				jQuery('.bucket-features .tabset').tabset('destroy');
			}
		}
	});
}